import promptLibraryJson from '../../../../prompt-library.json';
import { ChatProviderType } from '../../../../domain/chat/models/ChatProviderType';
import { ConversationStarterLibrary } from '../../../../domain/chat/models/ConversationStarterLibrary';
import { ProGPTAgent } from '../../../../domain/agents/models/Agent';
const promptLibrary = promptLibraryJson as ConversationStarterLibrary;


export const defaultProGPTAgent: ProGPTAgent = {

    agentId: 'progpt-default',
    providerType: ChatProviderType.ProGPT,
    name: 'ProGPT',
    description: 'ProGPT assistant',
    conversationStarters: promptLibrary,
};

export const mapProGPTAgentToMetadata = (): ProGPTAgent => defaultProGPTAgent;

